//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { useQuery } from '@tanstack/react-query';

import { getReels } from '@apis/reels/reelsApi';
import { TWENTY_SECONDS_STALE_TIME } from '@queries/QueryOptionsConstants';

export interface ReelsQueryParams {
  queryKey: string[];
}

export const useReelsQuery = ({ queryKey }: ReelsQueryParams) => {
  return useQuery({
    queryKey: [...queryKey],
    queryFn: ({ signal }) =>
      getReels(
        {
          noStats: true,
          includeModeratedCanvases: false,
        },
        { signal },
      ),
    staleTime: TWENTY_SECONDS_STALE_TIME,
  });
};
